import { render } from "./Alcohol.vue?vue&type=template&id=96524624&scoped=true"
import script from "./Alcohol.vue?vue&type=script&lang=js"
export * from "./Alcohol.vue?vue&type=script&lang=js"

import "./Alcohol.vue?vue&type=style&index=0&id=96524624&scoped=true&lang=css"

import exportComponent from "E:\\Github\\Vue\\drinks\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96524624"]])

export default __exports__